<div class="row" >
    <div class="col-lg-6">
        <app-field-viewer [(Oggetto)]="Data" [Campi]="fields"  ></app-field-viewer>
    </div>
    <div class="col-lg-6">
        <app-dynamic-task *ngIf="TaskStucture" [(Item)]="Task" [CampiNascosti]="['cliente', 'Utente','Ospite']" [DynamicFields]="TaskStucture"></app-dynamic-task>
        <div class="d-md-flex align-items-center justify-content-end m-b-10 m-r-10">

          <button type="submit" (click)="save()" style="margin: 0.75px;" class=" btn btn-success  waves-effect waves-light">
            <span class="mr-1 text-white "> Salva </span>
            <i class="far fa-save text-white"></i>
          </button>
          
        </div>
      </div>
</div>
